module.exports = __webpack_public_path__ + "static/media/password.bda712f5.jpg";